/**
 * Toggle WesQL lambda services
 *
 */
export default function switchLambdaService(): boolean {
  return process.env.NEXT_PUBLIC_DISABLE_WESQL_LEGACY_AWS_LAMBDA_API === 'true';
}
